const ApplyLeaveAdminActionType = {
	/** ****************************** APPLY LEAVE ADMIN *********************** */
	APPLY_LEAVE_ADMIN_START: 'apply_leave_admin_start',
	APPLY_LEAVE_ADMIN_SUCCESS: 'apply_leave_admin_success',
	APPLY_LEAVE_ADMIN_FAILURE: 'apply_leave_admin_failure',
	APPLY_LEAVE_ADMIN_RESPONSE_CHANGED: 'apply_leave_admin_response_changed',
	APPLY_LEAVE_ADMIN_RESPONSE_REST_START: 'apply_leave_admin_response_rest_start',
	/** ****************************** GET ALL EMPLOYEES FOR ADMIN *********************** */
	GET_ALL_EMPLOYEES_ADMIN_START: 'get_all_employees_admin_start',
	GET_ALL_EMPLOYEES_ADMIN_SUCCESS: 'get_all_employees_admin_success',
	GET_ALL_EMPLOYEES_ADMIN_FAILURE: 'get_all_employees_admin_failure',
	GET_ALL_EMPLOYEES_ADMIN_RESPONSE_CHANGED: 'get_all_employees_admin_response_changed',
	GET_ALL_EMPLOYEES_ADMIN_RESPONSE_REST_START: 'get_all_employees_admin_response_rest_start',

	// Encryption keys (must align with API secrets)
	APPLY_LEAVE_ADMIN_KEY: 'ApplyLeaveAdminFromWeb',
	GET_ALL_EMPLOYEES_ADMIN_KEY: 'GetAllEmployeesForLeaveAdminFromWeb',
} as const;

export default ApplyLeaveAdminActionType;
